export default __webpack_public_path__ + "static/justeat-takeaway-b25d64718cb27d207a66e8069ad6fdd7.png";